import React, { useEffect, useState } from "react";
import "./BalloonCelebration.css";

const BalloonCelebration = ({ isVisible }) => {
  const [balloons, setBalloons] = useState([]);

  useEffect(() => {
    if (isVisible) {
      // Create balloons with different colors and positions
      const newBalloons = Array.from({ length: 15 }, (_, index) => ({
        id: index,
        color: getRandomColor(),
        left: Math.random() * 100, // Random horizontal position
        delay: Math.random() * 2, // Random delay for staggered animation
        size: 50 + Math.random() * 40, // Random size between 50-90px for better proportions
      }));
      setBalloons(newBalloons);
    } else {
      setBalloons([]);
    }
  }, [isVisible]);

  const getRandomColor = () => {
    const colors = [
      "#FF6B6B", // Red
      "#4ECDC4", // Teal
      "#45B7D1", // Blue
      "#96CEB4", // Green
      "#FFEAA7", // Yellow
      "#DDA0DD", // Plum
      "#FFB347", // Orange
      "#98D8C8", // Mint
      "#F7DC6F", // Gold
      "#BB8FCE", // Purple
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  if (!isVisible) return null;

  return (
    <div className="balloon-celebration">
      {balloons.map((balloon) => (
        <div
          key={balloon.id}
          className="balloon"
          style={{
            left: `${balloon.left}%`,
            backgroundColor: balloon.color,
            width: `${balloon.size}px`,
            height: `${balloon.size}px`, // Keep it square for better balloon shape
            animationDelay: `${balloon.delay}s`,
          }}
        >
          <div className="balloon-string"></div>
        </div>
      ))}
    </div>
  );
};

export default BalloonCelebration;
